import React from 'react'
import { useLocation, useMatch, useNavigate, useParams } from 'react-router-dom'

const withRouter = Component => {
	function ComponentWithRouterProp(props) {
		let location = useLocation()
		let navigate = useNavigate()
		let params = useParams()
		let match = useMatch({ path: location.pathname })
		return (
			<Component {...props} router={{ location, navigate, params, match }} />
		)
	}

	return ComponentWithRouterProp
}
export default withRouter
